import { PROCESS_AUTH } from '../actions/authActions';

/**
 * Reducer to update the site language
 * @param {object} state
 * @param {object} action
 */
function auth(
  state = {
    token: '',
    sessionToken: '',
  },
  action
) {
  switch (action.type) {
    case PROCESS_AUTH:
      // This updates the set language to the one chosen in the interface or set by the browser
      return {
        ...state,
        token: action.payload.token,
        sessionToken: action.payload.sessionToken,
      };

    default:
  }

  return state;
}

export default auth;
